export default function EFArrowCircle(props: any) {
    return (
        <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity={props.opacity || 0.3}>
                <g id="CSR社会貢献" transform="translate(-1416.000000, -1201.000000)" stroke={props.stroke || '#000000'} strokeWidth="1.2">
                    <g
                        id="左右箭头"
                        transform="translate(1467.000000, 1221.000000) scale(-1, 1) translate(-1467.000000, -1221.000000) translate(1416.000000, 1201.000000)"
                    >
                        <g id="左右箭头" transform="translate(62.000000, 0.000000)">
                            <circle id="椭圆形备份" cx="20" cy="20" r="19.4"></circle>
                            <g id="编组-10备份" transform="translate(10.928571, 15.450081)">
                                <polyline
                                    id="路径"
                                    transform="translate(13.819018, 5.004464) rotate(45.000000) translate(-13.819018, -5.004464) "
                                    points="10.2803269 1.47208711 17.3577081 1.46577365 17.3513947 8.54315492"
                                ></polyline>
                                <line x1="0" y1="5.09583253" x2="18.2142857" y2="5.09583253" id="路径-11"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
